(function () {
  'use strict';

  /* @ngdoc object
   * @name productes.llista
   * @description
   *
   */
  angular
    .module('itecAdministracio.productes.main.llista', [
      'ui.router'
    ]);
}());
